document.addEventListener("DOMContentLoaded", function () {

  var carousels = document.querySelectorAll("[data-best-seller-carousel]");

  carousels.forEach(function (carousel) {

    var track = carousel.querySelector(".best-seller-track");

    if (!track) return;

    // clone items for infinite loop
    var items = Array.from(track.children);

    items.forEach(function(item) {
      var clone = item.cloneNode(true);
      track.appendChild(clone);
    });

    var currentX = 0;

    var step = 220; // khoảng nhảy
    var auto;

    var isPaused = false;
    var isDragging = false;

    var startX = 0;

    var nextBtn = carousel.querySelector(".best-seller-nav.next");
    var prevBtn = carousel.querySelector(".best-seller-nav.prev");

    track.style.transition = "transform 0.45s ease";

    // 🔥 AUTO STEP SLIDE
    function startAuto() {

      clearInterval(auto);

      auto = setInterval(function () {

        if (isPaused || isDragging) return;

        currentX -= step;

        var resetPoint = track.scrollWidth / 2;

        if (Math.abs(currentX) >= resetPoint) {
          currentX = 0;
          track.style.transition = "none";
          track.style.transform = "translateX(0px)";

          setTimeout(function () {
            track.style.transition = "transform 0.45s ease";
          }, 50);

          return;
        }

        track.style.transform =
          "translateX(" + currentX + "px)";

      }, 2500); // 🔥 thời gian pause
    }

    startAuto();

    // hover pause
    carousel.addEventListener("mouseenter", function () {
      isPaused = true;
    });

    carousel.addEventListener("mouseleave", function () {
      isPaused = false;
    });

    // drag desktop
    track.addEventListener("mousedown", function (e) {

      isDragging = true;

      startX = e.pageX - currentX;

      track.style.transition = "none";
    });

    window.addEventListener("mousemove", function (e) {

      if (!isDragging) return;

      currentX = e.pageX - startX;

      track.style.transform =
        "translateX(" + currentX + "px)";
    });

    window.addEventListener("mouseup", function () {

      if (!isDragging) return;

      isDragging = false;

      track.style.transition =
        "transform 0.45s ease";
    });

    // mobile swipe
    track.addEventListener("touchstart", function (e) {

      isDragging = true;

      startX = e.touches[0].clientX - currentX;

      track.style.transition = "none";
    });

    track.addEventListener("touchmove", function (e) {

      if (!isDragging) return;

      currentX =
        e.touches[0].clientX - startX;

      track.style.transform =
        "translateX(" + currentX + "px)";
    });

    track.addEventListener("touchend", function () {

      isDragging = false;

      track.style.transition =
        "transform 0.45s ease";
    });

    // buttons
    if (nextBtn) {

      nextBtn.addEventListener("click", function () {

        currentX -= step;

        track.style.transform =
          "translateX(" + currentX + "px)";
      });
    }

    if (prevBtn) {

      prevBtn.addEventListener("click", function () {

        currentX += step;

        track.style.transform =
          "translateX(" + currentX + "px)";
      });
    }

  });

});